import type { FC } from 'react';
import {
  withCellErrorBoundary,
  withCellValidationError,
} from '../cellRenderers';
import { ComponentCellRendererProps } from '../types';
import { CompletenessCellRenderer } from './applicationCompleteness/CompletenessCellRenderer';
import { CustomCellRendererName } from './customCellRendererNames';
import { FreshnessCellRenderer } from './applicationCompleteness/FreshnessCellRenderer';

/**
 * Registered on the grid via `gridOptions.components`, which resolves a
 * `cellRenderer` name to its component. Keying by `CustomCellRendererName`
 * makes every name in the union resolvable.
 */
export const customCellRenderersByName: Record<
  CustomCellRendererName,
  FC<ComponentCellRendererProps<unknown>>
> = {
  FreshnessCellRenderer: withCellErrorBoundary(
    withCellValidationError(FreshnessCellRenderer)
  ),
  CompletenessCellRenderer: withCellErrorBoundary(
    withCellValidationError(CompletenessCellRenderer)
  ),
};
